module.exports = __webpack_public_path__ + "media/images/emblems/Orges-coat_of_arms-167717ee48b15f8c1414b1878c7716a5.svg";